/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import {
  CREDIT_BEHAVIOUR_COLUMNS,
  CreditBehaviourDataRow
} from "@/Pages/Dashboard/LeftSide/types";

import { colors } from "@dotnet/telematics-design-system";

import CreditBehaviourMobileCard from "./CreditBehaviourMobileCard";

interface CreditBehaviourMobileTableProps {
  columns: CREDIT_BEHAVIOUR_COLUMNS[];
  dataRows: CreditBehaviourDataRow[];
}

const CreditBehaviourMobileTable = ({
  columns,
  dataRows
}: CreditBehaviourMobileTableProps) => {
  return (
    <div
      data-testid="credit-behaviour-mobile-table"
      css={css({
        overflow: "auto"
      })}
    >
      <div
        css={css([
          {
            transition: "opacity 300ms ease-out",

            background: colors.gray100,
            border: `1px solid ${colors.gray200}`,
            borderRadius: "8px",
            "& > div + div": {
              marginTop: "8px"
            }
          }
        ])}
      >
        {dataRows?.map((row: CreditBehaviourDataRow, rowIndex: number) => (
          <CreditBehaviourMobileCard
            key={`mobile_credit_card_${row.device}`}
            row={row}
            rowIndex={rowIndex}
            columns={columns}
          />
        ))}
      </div>
    </div>
  );
};

export default CreditBehaviourMobileTable;
